module.exports = __webpack_public_path__ + "img/logo-by-esmt-white.24764dd6.svg";